
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import BaseModal from '@components/new-styleguide/BaseModal.vue';
import IconOeamtcClose from '@/components/icons/icon-oeamtc-close.svg';

@Component({
  name: 'HeaderModal',
  components: {
    IconOeamtcClose,
    BaseModal,
  }
})
export default class FilterModal extends Vue {
  @Prop({ default: false })
  private open: boolean;

  @Prop({ required: true })
  private header: string;

  @Prop()
  private submitDisabled: boolean;

  private close() {
    this.$emit('close');
  }

  private submit() {
    this.$emit('submit');
  }
}
